import { render, staticRenderFns } from "./OwnerFilterChips.vue?vue&type=template&id=32067fa6&scoped=true&"
import script from "./OwnerFilterChips.vue?vue&type=script&lang=js&"
export * from "./OwnerFilterChips.vue?vue&type=script&lang=js&"
import style0 from "./OwnerFilterChips.vue?vue&type=style&index=0&id=32067fa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32067fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
